import { Buildings } from '@phosphor-icons/react';

export default Buildings;